<template>
  <v-app>
    <v-sheet dark color="black" width="100%" height="27">
        <v-row justify="end" class="mt-1 mr-4" >
            Update Property Owner Information
        </v-row>
    </v-sheet>
<v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step
        :complete="e1 > 1"
        step="1"
      >
        Property Owner Info step 1
      </v-stepper-step>

      <v-divider vertical></v-divider>

      <v-stepper-step
        :complete="e1 > 2"
        step="2"
      >
        Physical Address step 2
      </v-stepper-step>

      <v-divider vertical></v-divider>

      <v-stepper-step 
        :complete="e1 > 3"
        step="3">
        Mailing Address step 3
      </v-stepper-step>

      <v-divider vertical></v-divider>

      <v-stepper-step step="4">
        Secondary Contact step 4
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-row justify="center" class="ma-4">
            <v-card
            :elevation="e"
            class="mb-12"
            :color="c"
            :height="h"
            :width="w"
            >
            <v-row justify="center" class="mt-6"><h2>Property Owners Information</h2></v-row>
            <v-text-field 
                @input="checking"
                class="mx-4 mt-16"
                background-color="blue-grey lighten-5"
                placeholder=""
                v-model="accountinfo.BusName"
                persistent-placeholder
                outlined 
                label="Property Owner Name">
                
            </v-text-field>
            <v-text-field 
                v-model="accountinfo.DBAName"
                @input="checking"
                background-color="blue-grey lighten-5"
                class="mx-4"
                placeholder=""
                persistent-placeholder
                outlined 
                label="Business Name (optional)">
                test
            </v-text-field>
            <v-text-field 
                v-model="accountinfo.EMail"
                @input="checking"
                background-color="blue-grey lighten-5"
                class="mx-4"
                placeholder=""
                persistent-placeholder
                outlined 
                label="Email">
                test
            </v-text-field>
            <v-text-field 
                v-model="accountinfo.Phone"
                @input="checking"
                background-color="blue-grey lighten-5"
                class="mx-4"
                placeholder=""
                persistent-placeholder
                outlined 
                label="Phone">
                test
            </v-text-field>
            </v-card>
        </v-row>
        <v-btn
          :color="cb"
          dark
          @click="e1 = 2"
          elevation="6" 
        >
          Next
        </v-btn>

        <v-btn @click="cancel" text>
          Cancel
        </v-btn>
      </v-stepper-content>

      <v-stepper-content step="2">
        <v-row justify="center">
            <v-card
            class="mb-12"
            :color="c"
            :height="h"
            :width="w"
            :elevation="e"
            >
            <v-row justify="center" class="mt-10 mb-2">
                <h2>Property Owners Physical Address</h2>
            </v-row>
            
         <v-text-field 
                class="mx-4 mt-8"
                @input="checking"
                dense
                background-color="blue-grey lighten-5"
                placeholder=""
                v-model="accountinfo.LocAdr1"
                persistent-placeholder
                outlined 
                label="Physical Address Line 1">
                
            </v-text-field>
            <v-text-field 
                v-model="accountinfo.LocAdr2"
                @input="checking"
                dense
                background-color="blue-grey lighten-5"
                class="mx-4"
                placeholder=""
                persistent-placeholder
                outlined 
                label="Physical Address Line 2">
                test
            </v-text-field>
            <v-text-field 
                v-model="accountinfo.LocAdr3"
                @input="checking"
                dense
                background-color="blue-grey lighten-5"
                class="mx-4"
                placeholder=""
                persistent-placeholder
                outlined 
                label="Physical Address Line 3">
                test
            </v-text-field>
            <v-text-field 
                v-model="accountinfo.LocCity"
                @input="checking"
                dense
                background-color="blue-grey lighten-5"
                class="mx-4"
                placeholder=""
                persistent-placeholder
                outlined 
                label="Physical Address City">
                test
            </v-text-field>    
            <v-row>
                <v-col>
                    <v-text-field 
                        v-model="accountinfo.LocState"
                        @input="checking"
                        dense
                        background-color="blue-grey lighten-5"
                        class="mx-4"
                        placeholder=""
                        persistent-placeholder
                        outlined 
                        label="Physical Address State">
                        test
                    </v-text-field>  
                </v-col>
                <v-col>
                    <v-text-field 
                        v-model="accountinfo.LocZip"
                        @input="checking"
                        dense
                        background-color="blue-grey lighten-5"
                        class="mx-4"
                        placeholder=""
                        persistent-placeholder
                        outlined 
                        label="Physical Address Zip">
                        test
                    </v-text-field>  
                </v-col>
            
            </v-row>
            </v-card>
        </v-row>
        <v-btn
          :color="cb"
          dark
          @click="e1 = 3"
          elevation="6" 
        >
          Next
        </v-btn>

        <v-btn text @click="cancel">
          Cancel
        </v-btn>
      </v-stepper-content>

      <v-stepper-content step="3">
          <v-row justify="center">
            <v-card
            class="mb-12"
            :color="c"
            :height="h"
            :width="w"
            :elevation="e"
            >
            <v-row justify="center" class="mt-10 mb-2">
                <h2>Property Owners Mailing Address</h2>
            </v-row>
            <v-text-field 
                class="mx-4 mt-8"
                @input="checking"
                background-color="blue-grey lighten-5"
                dense
                placeholder=""
                v-model="accountinfo.MailAdr1"
                persistent-placeholder
                outlined 
                label="Mailing Address Line 1">
                
            </v-text-field>
            <v-text-field 
                v-model="accountinfo.MailAdr2"
                @input="checking"
                background-color="blue-grey lighten-5"
                dense
                class="mx-4"
                placeholder=""
                persistent-placeholder
                outlined 
                label="Mailing Address Line 2">
                test
            </v-text-field>
            <v-text-field 
                v-model="accountinfo.MailAdr3"
                @input="checking"
                background-color="blue-grey lighten-5"
                dense
                class="mx-4"
                placeholder=""
                persistent-placeholder
                outlined 
                label="Mailing Address Line 3">
                test
            </v-text-field>
            <v-text-field 
                v-model="accountinfo.MailCity"
                @input="checking"
                background-color="blue-grey lighten-5"
                dense
                class="mx-4"
                placeholder=""
                persistent-placeholder
                outlined 
                label="Mailing Address Phone">
                test
            </v-text-field>    
            <v-row>
                <v-col>
                    <v-text-field 
                        v-model="accountinfo.MailState"
                        @input="checking"
                        background-color="blue-grey lighten-5"
                        dense
                        class="mx-4"
                        placeholder=""
                        persistent-placeholder
                        outlined 
                        label="Mailing Address State">
                        test
                    </v-text-field>  
                </v-col>
                <v-col>
                    <v-text-field 
                        v-model="accountinfo.MailZip"
                        @input="checking"
                        background-color="blue-grey lighten-5"
                        dense
                        class="mx-4"
                        placeholder=""
                        persistent-placeholder
                        outlined 
                        label="Mailing Address Zip">
                        test
                    </v-text-field>  
                </v-col>
            
            </v-row>
            </v-card>
          </v-row>
        <v-btn
          :color="cb"
          @click="e1=4"
          elevation="6" 
          dark
        >
          Next
        </v-btn>

        <v-btn @click="cancel" text>
          Cancel
        </v-btn>
      </v-stepper-content>
      <v-stepper-content step="4">
        <v-row justify="center">
          <v-card 
            class="mb-12"
                :color="c"
                :height="h"
                :width="w"
                :elevation="e"

          >
                <v-card-title>
                  Property Owner Secondary Contact
                </v-card-title>
                <v-card-text>
                  <v-row>

                    <v-col class="mt-0">
                      <v-text-field @input="checking" :background-color="bc"  persistent-placeholder placeholder=" "   label="Name" v-model="sc.AddrOtherName"></v-text-field>
                      <v-text-field @input="checking" :background-color="bc"  persistent-placeholder placeholder=" "   label="Title" v-model="sc.AddrOtherTitle"></v-text-field>
                      <v-text-field @input="checking" :background-color="bc"  persistent-placeholder placeholder=" "   label="Phone" v-model="sc.AddrOtherPhone"></v-text-field>
                      <v-text-field @input="checking" :background-color="bc"  persistent-placeholder placeholder=" "   label="Email" v-model="sc.AddrOtherEMail"></v-text-field>
                    </v-col>
                    <v-divider vertical></v-divider>
                    <v-col>
                      <v-text-field @input="checking" :background-color="bc"  persistent-placeholder placeholder=" " dense outlined label="Address line 1" v-model="sc.AddrOtherAdr1"></v-text-field>
                      <v-text-field @input="checking" :background-color="bc"  persistent-placeholder placeholder=" " dense outlined label="Address line 2" v-model="sc.AddrOtherAdr2"></v-text-field>
                      <v-text-field @input="checking" :background-color="bc"  persistent-placeholder placeholder=" " dense outlined label="Address line 3" v-model="sc.AddrOtherAdr3"></v-text-field>
                      <v-text-field @input="checking" class="mt-2" :background-color="bc"  persistent-placeholder placeholder=" " dense outlined label="City" v-model="sc.AddrOtherCity"></v-text-field>
                      <v-row>
                        <v-col>
                          <v-text-field @input="checking" :background-color="bc"  persistent-placeholder placeholder=" " dense outlined label="State" v-model="sc.AddrOtherState"></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field @input="checking" :background-color="bc"  persistent-placeholder placeholder=" " dense outlined label="Zip" v-model="sc.AddrOtherZip"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    
                </v-row>
                </v-card-text>
              </v-card>
            </v-row>
          <v-btn
          :color="cb"
          @click="updateme"
          elevation="12" 
          dark
        >
          Submit
        </v-btn>

        <v-btn @click="cancel" text>
          Cancel
        </v-btn>
        </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
      <v-expand-transition>
        <v-card
          v-show="step1"
          :height="h"
          :width="w"
          class="mx-auto secondary"
        ></v-card>
      </v-expand-transition>
  </v-app>
</template>

<script>
import axios from 'axios'
export default {
    data(){
        return{
            check:0,
            e:18,
            h:450,
            w:450,
            c:"teal lighten-4",
            cb:"teal darken-4",
            bc:"blue-grey lighten-5",
            e1:1,
            step1:false,
            step2:false,
            step3:false,
            step4:false,
            end:false,
            accountinfo:[],
            addressinfo:[],
            sc:{
              AcctDb:'R',
              AcctNo:'',
              AddrOtherAdr1:'',
              AddrOtherAdr2:'',
              AddrOtherAdr3:'',
              AddrOtherCity:'',
              AddrOtherEMail:'',
              AddrOtherExt:'',
              AddrOtherMisc:'Secondary Contact',
              AddrOtherName:'',
              AddrOtherPhone:'',
              AddrOtherState:'',
              AddrOtherTitle:'',
              AddrOtherZip:'',
              AddrType:'',
              prikey:'',
            },
        }
    },
    mounted() {
      window.scrollTo(0,0);
      this.accountinfo=this.$store.state.accountinfo;
      this.addressinfo=this.$store.state.addressinfo;
      this.sc=this.$store.state.sc;
      let a=this.$store.state.Auth;
      if(a != "yes"){
        this.$router.replace({ name: "home" });
      }
    },
    methods:{
        checking(){
          this.check++;
        },
        cancel(){
            this.$store.commit('setUrlHistory','');
            this.$router.replace({ name: "loggedin" });
        },
        updateme(){
          if(this.check==0){
            this.$store.commit('setUrlHistory','loggedin');
            this.$router.replace({ name: "loggedin" });
          }else{
            this.check=0;
            let url = this.$store.state.url;
            let thisvue=this;
            this.accountinfo.sc=this.sc;
            let d=JSON.stringify(this.accountinfo);
            const params = new URLSearchParams();
            params.append('ty', 'updateldata');
            params.append('data', d);
            axios({
                method:"post",
                url:url,
                data:params
            })
            .then(function(response){
                if(response.data=="good"){
                    thisvue.$store.commit('setUrlHistory','updatedata');
                    thisvue.$router.replace({ name: "loggedin" });
                }
            });
        }
      }
    }
}
</script>

<style>

</style>